import type { ReactNode } from "react";

export function SectionCard({
  title,
  headerRight,
  children,
}: {
  title: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="flex w-full min-w-0 flex-col items-stretch">
      {/* Figma 799:1574 — px-20 py-16, title 16px medium, rounded-t 8px, opacity-96 */}
      <div className="relative flex w-full shrink-0 flex-col items-start overflow-clip rounded-t-md border-l border-r border-t border-border bg-surface-header px-5 py-4 opacity-[0.96] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
        <div className="relative flex w-full shrink-0 items-center justify-between gap-3">
          <p className="min-w-0 truncate text-base font-medium leading-normal text-foreground">
            {title}
          </p>
          {headerRight}
        </div>
        <div
          className="pointer-events-none absolute inset-0 rounded-t-md dark:shadow-[inset_0px_-1px_0px_0px_rgba(0,0,0,0.1)]"
          aria-hidden
        />
      </div>
      {children}
    </div>
  );
}

export function SectionBody({
  children,
  className = "",
  rounded = true,
}: {
  children: ReactNode;
  className?: string;
  rounded?: boolean;
}) {
  return (
    <div
      className={`flex w-full min-w-0 shrink-0 flex-col items-stretch border-b border-l border-r border-t border-border bg-surface-elevated p-5 ${rounded ? "rounded-b-md" : ""} ${className}`.trim()}
    >
      {children}
    </div>
  );
}
